import Tooltip from './Tooltip';
import { cn } from '@/lib/utils';

interface FieldLabelProps {
  children: React.ReactNode;
  /**
   * What this control actually does, in the designer's terms.
   *
   * Write it about the STOREFRONT, not the field. "Buttons, links and the
   * footer band" is useful; "the primary colour" is the label again.
   */
  help?: string;
  htmlFor?: string;
  className?: string;
}

/**
 * A form label with an optional help tip beside it.
 *
 * Exists because the design surfaces had a `Tooltip` component and zero uses of
 * it: labels like "Primary Color" and "Warm Background" name the token without
 * saying what changes on the site when you move them. An outside designer is
 * left clicking a swatch to find out, which is exactly the loop the sandbox was
 * built to avoid.
 *
 * The tip is a SIBLING of the `<label>`, never a child. A focusable element
 * inside a label competes with the label's own click-to-focus behaviour, and
 * clicking the help icon would move focus to the input instead of showing the
 * tip.
 */
export default function FieldLabel({ children, help, htmlFor, className }: FieldLabelProps) {
  return (
    <div className={cn('mb-1 flex items-center gap-1.5', className)}>
      <label htmlFor={htmlFor} className="text-sm font-medium text-ink">
        {children}
      </label>
      {help && <Tooltip content={help} />}
    </div>
  );
}
